import axios from 'axios'



//let baseurl = 'http://192.168.15.203:3002/'
// let baseurl = 'http://192.168.15.109:3002/';
let baseurl = 'https://rsrefeicoes-backend.onrender.com/';
//let baseurl = 'http://170.233.229.250:7885/'

const url = window.location.href


// if(url.includes("localhost")) {
//     baseurl = 'http://ftptrade.ddns.net:3002/'
//     //baseurl = 'http://localhost:3002/'
// }



const apiClient = axios.create({
    baseURL: 'http://ftptrade.ddns.net/amrg/api/client/',
    timeout: 15000
})

const apiEmployee = axios.create({
    baseURL: baseurl,
    timeout: 15000
})

export {apiClient, apiEmployee}
